/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_No_Matching_WebsitesInputs */

const en_common_no_matching_websites = /** @type {(inputs: Common_No_Matching_WebsitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching websites found`)
};

const es_common_no_matching_websites = /** @type {(inputs: Common_No_Matching_WebsitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron sitios`)
};

/**
* | output |
* | --- |
* | "No matching websites found" |
*
* @param {Common_No_Matching_WebsitesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_no_matching_websites = /** @type {((inputs?: Common_No_Matching_WebsitesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_No_Matching_WebsitesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_no_matching_websites(inputs)
	return en_common_no_matching_websites(inputs)
});